<template>
  <div class="home">
    <a-spin size="large" :spinning="loading">
      <div class="dashbordData">
        <ul>
          <li>
            <div class="tit" :class="[lang]">{{ $t("TotalNumber") }}</div>
            <div class="data">
              <span class="number">{{
                dashBorderData.customer_find ? dashBorderData.customer_find : 0
              }}</span>
            </div>
          </li>
          <li>
            <div class="tit" :class="[lang]">
              {{ $t("ConnectionsRequest") }}
            </div>
            <div class="data incluedRate">
              <span class="number">{{
                dashBorderData.connections_request
                  ? dashBorderData.connections_request
                  : 0
              }}</span>
            </div>
          </li>
          <li>
            <div class="tit" :class="[lang]">{{ $t("ConnectionsMade") }}</div>
            <div class="data">
              <span class="number">{{
                dashBorderData.connections_made
                  ? dashBorderData.connections_made
                  : 0
              }}</span>
            </div>
          </li>
          <li>
            <div class="tit" :class="[lang]">{{ $t("Acceptedrate") }}</div>
            <div class="data">
              <span class="number"
                >{{
                  dashBorderData.accept_rate ? dashBorderData.accept_rate : 0
                }}%</span
              >
            </div>
          </li>
          <li style="border-right: none">
            <div class="tit" :class="[lang]">{{ $t("NumberOfGreeters") }}</div>
            <div class="data">
              <span class="number">{{
                dashBorderData.greeting_count
                  ? dashBorderData.greeting_count
                  : 0
              }}</span>
            </div>
          </li>
        </ul>
        <ul style="margin-top: 26px">
          <li>
            <div class="tit" :class="[lang]">{{ $t("Replies") }}</div>
            <div class="data">
              <span class="number">{{
                dashBorderData.replies ? dashBorderData.replies : 0
              }}</span>
            </div>
          </li>
          <li>
            <div class="tit" :class="[lang]">{{ $t("Repliesrate") }}</div>
            <div class="data">
              <span class="number"
                >{{
                  dashBorderData.replies_rate ? dashBorderData.replies_rate : 0
                }}%</span
              >
            </div>
          </li>
          <li>
            <div class="tit" :class="[lang]">{{ $t("Message") }}</div>
            <div class="data">
              <span class="number">{{
                dashBorderData.message ? dashBorderData.message : 0
              }}</span>
            </div>
          </li>
          <li>
            <div class="tit" :class="[lang]">{{ $t("PotentialLeads") }}</div>
            <div class="data">
              <span class="number">{{
                dashBorderData.leads ? dashBorderData.leads : 0
              }}</span>
            </div>
          </li>
          <li style="border-right: none">
            <div class="tit" :class="[lang]">{{ $t("ConversionRate") }}</div>
            <div class="data">
              <span class="number"
                >{{ dashBorderData.rate ? dashBorderData.rate : 0 }}%</span
              >
            </div>
          </li>

          <!-- <li style="border-right: none">
            <div class="tit" :class="[lang]">{{ $t("ExistingFriends") }}</div>
            <div class="data">
              <span class="number">{{
                dashBorderData.existing_friends
                  ? dashBorderData.existing_friends
                  : 0
              }}</span>
            </div>
          </li>
          <li></li> -->
        </ul>
      </div>
      <div class="title">
        <svg-icon iconClass="hot"></svg-icon
        ><span :class="[lang]">{{ $t("Hotconversataion") }}</span>
      </div>
      <div
        class="hotList"
        :class="{ noDataWrap: hotData.length == 0 ? true : false }"
      >
        <ul v-if="hotData.length > 0">
          <li
            @click="skipDialog(item)"
            v-for="(item, index) in hotData"
            :key="index"
          >
            <div class="labelFlag" v-if="item.has_contact">
              {{ $t("LeadGenerated") }}
            </div>
            <div class="user" @click.stop="">
              <div class="user-img">
                <img
                  v-if="item.head_img"
                  style="cursor: pointer"
                  @click="skipDialog(item)"
                  :src="item.head_img"
                />
                <img v-else src="@/assets/img/avat.png" />
                <span class="name">{{ item.customer_name }}</span>
              </div>

              <a-switch
                class="switch"
                size="small"
                :checked-children="$t('In')"
                :un-checked-children="$t('Out')"
                :checked="!!item.talk_flag"
                @change="changeTalkFlag(item)"
                style="margin-right: 5px"
              />
              <a-tooltip
                v-model="showHotTips"
                placement="bottomRight"
                v-if="index == 0"
              >
                <template slot="title">
                  <p style="font-size: 12px">
                    {{ $t("TostopAIcommunication") }}
                  </p>
                </template>
                <span
                  ><a-icon type="question-circle" style="font-size: 14px" />
                </span>
              </a-tooltip>
              <a-tooltip
                :placement="
                  index + 1 == hotData.length ? 'leftBottom' : 'bottom'
                "
                v-else
              >
                <template slot="title">
                  <p style="font-size: 12px">
                    {{ $t("TostopAIcommunication") }}
                  </p>
                </template>
                <span
                  ><a-icon type="question-circle" style="font-size: 14px" />
                </span>
              </a-tooltip>
            </div>
            <div class="info">
              <span
                class="label"
                :class="[lang]"
                :style="{
                  'min-width':
                    lang == 'US' ? '66px' : lang == 'CN' ? '33px' : '33px',
                }"
                >{{ $t("Company") }}:</span
              >
              <span class="val">{{ item.company ? item.company : "--" }}</span>
            </div>
            <div class="info">
              <span class="label" :class="[lang]"
                >{{ $t("Conversation") }}:</span
              >
            </div>
            <div class="message">
              {{ item.content }}
            </div>
            <div class="info m15">
              <span
                class="label"
                :style="{
                  'min-width':
                    lang == 'US' ? '66px' : lang == 'CN' ? '33px' : '33px',
                }"
                :class="[lang]"
                >{{ $t("campaign") }}:</span
              >
              <span class="val">{{ item.campaign_name }}</span>
            </div>
            <div class="info">
              <span
                class="label"
                :style="{
                  'min-width':
                    lang == 'US' ? '105px' : lang == 'CN' ? '60px' : '80px',
                }"
                :class="[lang]"
                >{{ $t("LinkedIn") }}:</span
              >
              <span class="val">{{ item.linkedin_email }}</span>
            </div>
          </li>
        </ul>
        <NoData :lang="lang" :text="$t('noHotData')" v-else />
      </div>
      <div class="wrap-table">
        <div class="title title2">
          <div>
            <svg-icon iconClass="active"></svg-icon
            ><span :class="[lang]">{{ $t("RecentCampaign") }}</span>
          </div>
          <div class="campaignsDetail" @click="goMore">
            <span :class="[lang]">{{ $t("ViewAllCampaigns") }}</span
            ><a-icon class="ir" type="right" />
          </div>
        </div>
        <a-table
          :class="{ arTable: lang == 'AR' ? true : false }"
          :scroll="{
            x: 1120,
          }"
          :locale="{ emptyText: $t('noCamp') }"
          size="middle"
          :columns="columns"
          :rowKey="(record, index) => index"
          :data-source="capinData"
          :pagination="false"
          class="capinTable"
          :loading="loading"
          :row-class-name="
            (_record, index) => (index % 2 !== 1 ? 'table-bg' : null)
          "
        >
          <template slot="ProspectiveClients" slot-scope="text, record">
            <span class="skipDetail" @click="goDetail(record, '')">{{
              record.customer_find
            }}</span>
          </template>

          <template slot="connectionsRequest" slot-scope="text, record">
            <span class="skipDetail" @click="goDetail(record, '1')">{{
              record.connections_request
            }}</span>
          </template>

          <template slot="ConnectionsMade" slot-scope="text, record">
            <span class="skipDetail" @click="goDetail(record, '2')">{{
              record.connections_made
            }}</span>
          </template>

          <template slot="NumberOfGreeters" slot-scope="text, record">
            <span class="skipDetail" @click="goDetail(record, '2')">{{
              record.greeting_count
            }}</span>
          </template>

          <template slot="replies" slot-scope="text, record">
            <span class="skipDetail" @click="goDetail(record, '4')">{{
              record.replies
            }}</span>
          </template>

          <template slot="status" slot-scope="text, record" class="arial">
            <div class="wrap-bar">
              <div class="statusbox" @click.stop="">
                <span v-if="record.status == '1'" :class="[lang]">{{
                  $t("Active")
                }}</span>
                <span v-if="record.status == '0'" :class="[lang]">{{
                  $t("Paused")
                }}</span>
                <!-- <img
                  v-if="record.status == '1'"
                  src="@/assets/img/s.png"
                  class="swing"
                /> -->
                <!-- <svg-icon iconClass="sactive"></svg-icon> -->
              </div>
              <div @click.stop="">
                <a-switch
                  size="small"
                  v-model="record.status"
                  @change="onChangeRecord(record)"
                />
              </div>
              <!-- <div class="bar">21212</div> -->
            </div>
          </template>

          <template slot="action" slot-scope="text, record" class="arial">
            <a-dropdown>
              <template #overlay>
                <a-menu>
                  <a-menu-item key="0" @click="goEdit(record)">
                    <a-icon type="form" />
                    <span :class="[lang]">{{ $t("campaignEdit") }}</span>
                  </a-menu-item>
                  <a-menu-item key="1" @click="goDetail(record)">
                    <a-icon type="edit" />
                    <span :class="[lang]">{{ $t("Details") }}</span>
                  </a-menu-item>
                  <a-menu-item key="2" @click="copyHandler(record)">
                    <a-icon type="copy" />
                    <span :class="[lang]">{{ $t("Copy") }}</span>
                  </a-menu-item>
                  <a-menu-item key="3" @click="deleteHandler(record)">
                    <a-icon type="delete" />
                    <span :class="[lang]">{{ $t("Delete") }}</span>
                  </a-menu-item>
                </a-menu>
              </template>
              <a-button style="padding: 0 8px" @click.stop="">
                <span :class="[lang]">{{ $t("Action") }}</span>
                <a-icon type="down" />
              </a-button>
            </a-dropdown>
          </template>

          <template slot="campaign_name" slot-scope="text, record">
            {{ record.campaign_name }}
            <CampaignTableTip
              :record="record.action_log"
              v-if="record && record.action_log"
              lable="click_history_records"
              event="home"
              method="sales"
            />
          </template>

          <template slot="linkedin_email" slot-scope="text, record">
            <a-tooltip placement="bottom" v-if="record.is_not_friend">
              <template slot="title">
                <span>{{ $t("baibanCampaignTipTxt") }}</span>
              </template>
              <a-icon
                type="exclamation-circle"
                class="linkedin_email_warning"
              />
            </a-tooltip>
            {{ record.linkedin_email }}
          </template>
        </a-table>
      </div>
    </a-spin>
    <CampaignModalCon
      :showModal.sync="showModal"
      v-if="showModal"
      @saveLinkedIn="saveLinkedIn"
      :newLinkedIn="newLinkedIn"
    />
    <save-success-modal
      v-if="modalVisible"
      :visible="modalVisible"
      :queterInfo="queterInfo"
      @manage="handleManageCampaigns"
    />
  </div>
</template>

<script>
import CampaignTableTip from "../../hr/recruiter/component/campaignTableTip.vue";
import CampaignModalCon from "@/layouts/globalModals/CampaignModalCon";
import { mapGetters } from "vuex";
import SaveSuccessModal from "@/components/saveSuccessModal";

export default {
  components: {
    CampaignTableTip,
    CampaignModalCon,
    SaveSuccessModal,
  },
  data() {
    return {
      modalVisible: false,
      queterInfo: {},
      loading: false,
      dashBorderData: {},
      capinData: [],
      hotData: [],
      newLinkedIn: [],
      showModal: false,
      showHotTips: false,
      new_linkedin_id: 0,
    };
  },
  i18n: require("./i18n"),
  computed: {
    columns: {
      get() {
        let that = this;
        return [
          {
            title: that.$t("Name"),
            width: 200,
            dataIndex: "campaign_name",
            // align: "center",
            // ellipsis: true,
            // fixed: "left",
            scopedSlots: {
              customRender: "campaign_name",
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("Status"),
            width: 160,
            dataIndex: "status",
            align: "center",
            // fixed: "left",
            scopedSlots: {
              customRender: "status",
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("LinkedinlD"),
            width: 200,
            dataIndex: "linkedin_email",
            ellipsis: true,
            align: "left",
            scopedSlots: {
              customRender: "linkedin_email",
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("Days"),
            width: 120,
            dataIndex: "days",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("TotalNumber"),
            width: that.lang == "US" ? 260 : that.lang == "AR" ? 200 : 120,
            dataIndex: "customer_find",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
            scopedSlots: {
              customRender: "ProspectiveClients",
            },
          },
          {
            title: that.$t("ConnectionsRequest"),
            width: that.lang == "US" ? 200 : that.lang == "AR" ? 200 : 120,
            dataIndex: "connections_request",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
            scopedSlots: {
              customRender: "connectionsRequest",
            },
          },
          {
            title: that.$t("ConnectionsMade"),
            width: that.lang == "US" ? 200 : that.lang == "AR" ? 200 : 120,
            dataIndex: "connections_made",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
            scopedSlots: {
              customRender: "ConnectionsMade",
            },
          },

          {
            title: that.$t("Acceptedrate"),
            width: 120,
            dataIndex: "accept_rate",
            align: "center",
            customRender: function (text) {
              return text ? text + "%" : "0%";
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("NumberOfGreeters"),
            width: that.lang == "US" ? 200 : that.lang == "AR" ? 200 : 120,
            dataIndex: "greeting_count",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
            scopedSlots: {
              customRender: "NumberOfGreeters",
            },
          },

          {
            title: that.$t("Replies"),
            width: 120,
            dataIndex: "replies",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
            scopedSlots: {
              customRender: "replies",
            },
          },
          {
            title: that.$t("Repliesrate"),
            width: that.lang == "US" ? 140 : that.lang == "AR" ? 200 : 120,
            dataIndex: "replies_rate",
            align: "center",
            customRender: function (text) {
              return text ? text + "%" : "0%";
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("Message"),
            width: 120,
            dataIndex: "message",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("PotentialLeads"),
            width: that.lang == "US" ? 120 : that.lang == "AR" ? 200 : 120,
            dataIndex: "potential_leads",
            align: "center",
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
          {
            title: that.$t("ConversionRate"),
            width: 120,
            dataIndex: "potential_leads_rate",
            align: "center",
            customRender: function (text) {
              return text ? text + "%" : "0%";
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },

          {
            title: that.$t("Action"),
            align: "center",
            fixed: "right",
            width: 120,
            scopedSlots: {
              customRender: "action",
            },
            customCell: (record) => {
              return that.getCustomCell(record);
            },
          },
        ];
      },
    },
    ...mapGetters("account", ["user"]),
  },
  activated() {
    this.initData();
  },
  created() {},
  methods: {
    handleManageCampaigns() {
      this.modalVisible = false;
      this.$router.push({
        path: "/setting/campaign",
        query: {
          id: this.new_linkedin_id,
        },
      });
    },
    changeTalkFlag(item) {
      this.writeLog("home", "sales", "click_opt");
      item.talk_flag = item.talk_flag ? false : true;
      this.$axios(
        "/sales/switch_talk_flag",
        {
          talk_flag: item.talk_flag ? 1 : 0,
          campaign_id: parseInt(item.campaign_id),
          friend_id: item.customer_id,
        },
        "post",
      );
    },
    initData() {
      this.loading = true;
      Promise.all([
        this.getBordeData(),
        this.getCampinData(),
        this.getHotData(),
      ]).then(() => {
        let { queuepopup } = this.$route.query;
        if (queuepopup) {
          this.$axios(
            "/sales/campaign_queue_pop",
            {
              // campaign_id: parseInt(campaign_id),
            },
            "post",
          ).then((resp) => {
            this.loading = false;
            if (resp.code == 200) {
              this.queterInfo = resp.data;
              if (
                sessionStorage.getItem("queuepopupCampaignName") !==
                resp.data.campaign_name
              ) {
                sessionStorage.setItem(
                  "queuepopupCampaignName",
                  resp.data.campaign_name,
                );
                this.modalVisible = true;
                this.new_linkedin_id = resp.data.linkedin_info.linkedin_id;
              }
            }
          });
        } else {
          this.loading = false;
        }
      });
    },
    deleteHandler(record) {
      let that = this;
      this.writeLog("home", "sales", "click_action_delete");
      this.$confirm({
        title: that.$t("confirmDel") + "?",
        // content: h => <div style="color:red;">Some descriptions</div>,
        onOk() {
          that
            .$axios(
              "/sales/campaign_delete",
              { campaign_id: record.id },
              "post",
            )
            .then((res) => {
              if (res.code == 200) {
                that.getCampinData();
              }
            });
        },
        onCancel() {},
        class: "test",
      });
    },
    copyHandler(record) {
      this.writeLog("home", "sales", "click_action_copy");
      let { id } = record;
      if (this.user.has_customer_info) {
        this.$router.push({
          path: "/sales/salesReps/createCampaign",
          query: { campaign_id: id, edit: 1 },
        });
      } else {
        this.$router.push({
          path: "/sales/salesReps/collectUserInfo",
          query: { campaign_id: id, edit: 1 },
        });
      }
    },
    getHotData() {
      return new Promise((resolve) => {
        this.$axios("/sales/hot_conversatin", {}, "post").then((res) => {
          if (res.code == 200) {
            this.hotData = res.data;
          }
          setTimeout(() => {
            this.showHotTips = true;
            setTimeout(() => {
              this.showHotTips = false;
            }, 6000);
            resolve();
          }, 1000);
        });
      });
    },
    getCampinData() {
      return new Promise((resove) => {
        this.$axios("/sales/recent_campaign", {}, "post").then((res) => {
          if (res.code == 200) {
            let arr = [];
            res.data.forEach((item) => {
              item.status = item.status == 0 ? false : true;
              arr.push(item);
            });
            this.capinData = arr;
            // console.log(this.$router.history, this.$route.from);
            // if (arr.length == 0) {
            //   this.$router.replace({ path: "/sales/salesReps/campaign" });
            // }
          }
          resove();
        });
      });
    },
    getBordeData() {
      return new Promise((resove) => {
        this.$axios("/sales/home_dashboard", {}, "post").then((res) => {
          if (res.code == 200) {
            this.dashBorderData = res.data;
          }
          resove();
        });
      });
    },
    goMore() {
      // this.writeLog("home", "sales", "click_history_records");
      this.$router.push({ path: "/sales/salesReps/campaign" });
    },
    goDetail(record, skipStatus) {
      this.writeLog("home", "sales", "click_action_detail");
      let { id, status } = record;
      this.$router.push({
        path: "/sales/salesReps/campaignDetail",
        query: {
          campaign_id: id,
          customer_status: status ? 1 : 0,
          status: skipStatus,
        },
      });
    },
    skipDialog(obj) {
      this.writeLog("home", "sales", "click_conver_card");
      let { campaign_id, customer_id } = obj;
      this.$router.push({
        path: "/sales/salesReps/dialogue",
        query: { campaign_id, customer_id },
      });
    },
    onChangeRecord(record) {
      let { id, status } = record;
      this.writeLog("home", "sales", "click_campaign_status");
      if (record.is_not_friend) {
        this.showModal = true;
        this.newLinkedIn = [record.linkedin_email];
        record.status = !record.status;
        return;
      }
      this.$axios(
        "/sales/campaign_change_status",
        { campaign_id: id, change_status: status ? 1 : 0 },
        "post",
      ).then((res) => {
        let { code, data } = res;
        if (code == 200) {
          if (data.result == 1) {
            this.getCampinData();
          } else {
            record.status = !status;
            this.$warning({
              content: this.$t("statusChangeTip"),
              okText: this.$t("goSet"),
            });
          }
        } else {
          record.status = !status;
        }
      });
    },
    handleMenuClick(val) {
      console.log(val, arguments);
    },
    getCustomCell(record) {
      if (
        record.action_log &&
        record.action_log.action_log &&
        record.action_log.action_log.length > 0
      ) {
        return {
          style: {
            "padding-bottom": "66px",
          },
        };
      }
    },
    goEdit(record) {
      this.writeLog("home", "sales", "click_action_edit");
      let { id } = record;
      this.$router.push({
        path: "/sales/salesReps/createCampaign",
        query: {
          campaign_id: id,
          edit: 2,
        },
      });
    },
    saveLinkedIn() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  // margin-top: 50px;
  padding: 20px 30px;
  ul,
  li {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .dashbordData {
    // height: 116px;
    background: #fff;
    padding-top: 26px;
    padding-bottom: 26px;
    ul {
      display: flex;
    }
    li {
      height: 64px;
      list-style: none;
      flex: 1;
      text-align: center;
      border-right: solid 1px #e5e5e5;
      .tit {
        font-family: Arial, Arial;
        font-weight: 400;
        font-size: 14px;
        color: #80829f;
      }
      .data {
        margin-top: 7px;
        height: 41px;
        .number {
          font-family: Arial, Arial;
          font-weight: bold;
          display: inline-block;
          font-size: 36px;
          height: 36px;
          line-height: 36px;
          color: #0e756a;
        }
      }
      .incluedRate {
        display: flex;
        align-items: flex-end;
        justify-content: center;

        p {
          font-family: Arial, Arial;
          font-weight: 400;
          font-size: 12px;
          color: #0094ff;
          background: #e5f4ff;
          border-radius: 2px 2px 2px 2px;
          padding: 1px 5px;
          margin-left: 7px;
          margin-bottom: 6px;
          text-align: left;
        }
      }
    }
  }
  .title {
    padding: 20px 0 14px 0;
    span {
      font-family: Arial, Arial;
      font-weight: 400;
      font-size: 20px;
      color: #000000;
      display: inline-block;
      vertical-align: middle;
      margin-left: 10px;
    }
  }
  .title2 {
    display: flex;
    justify-content: space-between;
    .campaignsDetail {
      font-weight: 400;
      font-size: 14px;
      color: #0e756a;
      cursor: pointer;
      .ir {
        font-size: 12px;
        font-weight: bold;
      }
    }
  }
  .hotList {
    border-radius: 4px;
    background: #fff;
    min-height: 292px;
    ul {
      display: flex;
      li {
        width: 20%;
        padding: 22px;
        width: 20%;
        border: #fff 1px solid;
        position: relative;
        .labelFlag {
          position: absolute;
          right: 12px;
          top: -12px;
          background-color: #0c6158;
          color: #fff;
          height: 24px;
          padding: 0 10px;
          line-height: 24px;
          border-radius: 12px;
        }
        .user {
          display: flex;
          align-items: center;
          .user-img {
            flex: 1;
            display: flex;
            align-items: center;
            img {
              width: 22px;
              height: 22px;
              border-radius: 50%;
              background: #ccc;
            }
            .name {
              font-family: Arial, Arial;
              font-weight: bold;
              font-size: 16px;
              color: #000000;
              margin-left: 14px;
              display: flex;
              height: 36px;
              align-items: center;
            }
          }
          .switch {
          }
        }
        .info {
          margin-top: 20px;
          display: flex;
          .label {
            font-family: Arial, Arial;
            font-weight: 400;
            font-size: 13px;
            color: #666666;
            display: inline-block;
            min-width: 64px;
          }
          .val {
            font-family: Arial, Arial;
            font-weight: bold;
            font-size: 13px;
            line-height: 18px;
            max-height: 18px;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            white-space: normal;
          }
        }
        .m15 {
          margin-top: 15px;
        }
        .message {
          background: #f3f3f3;
          border-radius: 4px;
          padding: 11px;
          line-height: 24px;
          margin-top: 6px;
          height: 88px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
        }
      }
      li:hover {
        box-shadow: 0px 0px 14px 1px rgba(14, 117, 106, 0.3);
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #0e756a;
      }
    }
  }
  .wrap-table {
    padding: 0px 20px 12px 20px;
    background: #fff;
    border-radius: 4px;
    margin-top: 20px;
  }
  /deep/.ant-table-row-hover {
    background: rgba(238, 248, 247, 1) !important;
  }
  /deep/.ant-btn {
    background: #0c6158;
    color: #fff;
  }
  .noDataWrap {
    position: relative;
    /deep/.noData {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .capinTable {
    /deep/ tr.ant-table-row {
      position: relative;
    }
  }
}
.wrap-bar {
  position: relative;
  .bar {
    position: absolute;
    border-radius: 4px;
    background: rgba(105, 142, 138, 0.7);
    width: 200px;
  }
}
/deep/.ant-modal-confirm-body .ant-modal-confirm-content {
  margin-left: 36px;
}
/deep/.ant-modal-confirm-content {
  margin-left: 36px;
}

@keyframes swing {
  0% {
    transform: translateX(0);
  }
  10% {
    transform: translateX(-5px);
  }
  30% {
    transform: translateX(5px);
  }
  50% {
    transform: translateX(-5px);
  }
  70% {
    transform: translateX(5px);
  }
  100% {
    transform: translateX(0);
  }
}

.swing {
  animation: swing 1s infinite alternate;
}
.skipDetail {
  color: #0e756a;
  cursor: pointer;
}
// /deep/.ant-table-row {
//   cursor: pointer;
// }
.linkedin_email_warning {
  color: #c92222;
  margin-right: 4px;
  font-weight: bold;
}
</style>
